/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Barge_DetailInputs */



/**
* | output |
* | --- |
* | "Inspections of inland and coastal barges under the Barge Inspection Report Exchange (BIRE) and the European Barge Inspection Scheme (EBIS). They cover the ve..." |
*
* @param {Service_Barge_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_barge_detail = /** @type {((inputs?: Service_Barge_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Barge_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("依据驳船检查报告交换（BIRE）和欧洲驳船检查计划（EBIS）对内河及沿海驳船开展的检查。检查对照相应计划的问卷，涵盖船舶状况、货物系统和管理。")
	return /** @type {LocalizedString} */ ("Inspections of inland and coastal barges under the Barge Inspection Report Exchange (BIRE) and the European Barge Inspection Scheme (EBIS). They cover the vessel's condition, cargo systems and management against the relevant scheme's questionnaire.")
});